var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlarm4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#02D924"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6673 37.4666L51.831 28.9499C52.0059 28.8273 52.2111 28.7551 52.4242 28.7411C52.6374 28.7271 52.8503 28.7719 53.0397 28.8706C53.2291 28.9693 53.3878 29.1181 53.4985 29.3007C53.6092 29.4834 53.6676 29.693 53.6673 29.9066V58.0933C53.6676 58.3068 53.6092 58.5164 53.4985 58.6991C53.3878 58.8818 53.2291 59.0306 53.0397 59.1293C52.8503 59.2279 52.6374 59.2727 52.4242 59.2588C52.2111 59.2448 52.0059 59.1725 51.831 59.0499L39.6673 50.5333V60.3333C39.6673 60.9521 39.4215 61.5456 38.9839 61.9832C38.5463 62.4208 37.9528 62.6666 37.334 62.6666H4.66732C4.04848 62.6666 3.45499 62.4208 3.0174 61.9832C2.57982 61.5456 2.33398 60.9521 2.33398 60.3333V27.6666C2.33398 27.0477 2.57982 26.4543 3.0174 26.0167C3.45499 25.5791 4.04848 25.3333 4.66732 25.3333H37.334C37.9528 25.3333 38.5463 25.5791 38.9839 26.0167C39.4215 26.4543 39.6673 27.0477 39.6673 27.6666V37.4666ZM11.6673 34.6666V39.3333H16.334V34.6666H11.6673Z",
    fill: "#02D924"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm4);
export default __webpack_public_path__ + "static/media/Icon_Alarm-4.bdfcf42bed54a0bab7861992ae5938fd.svg";
export { ForwardRef as ReactComponent };